enum CookieKey {
  OAUTH_TOKEN = 'auth',
  ORGANISATION_ID = 'org',
  USER_AUTHORITY = 'user_authority',
  USER_FULL_NAME = 'user',
  USER_ID = 'userId',
}

export default CookieKey;
